module.exports = __webpack_public_path__ + "img/CallusReactionPhases.751f2cea.png";